import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/registry/contracts')({
  component: undefined,
  context: () => ({
    getBreadcrumbData: () => ({
      id: null,
      translationKey: 'breadcrumbs.contracts',
    }),
  }),
  beforeLoad: ({ location }) => {
    if (location.pathname === '/registry/contracts') {
      throw redirect({
        to: '/dashboard/contracts',
      });
    }
  },
});
